<template>
  <div @click="" :style='{
    display: "flex",
    flexDirection: "column",
    borderBottom: HNewGameUIConfig.newGameUIType === 3?"#2a2a2a 1px solid":"#f6f6f6 1px solid",
    backgroundColor: HNewGameUIConfig.newGameUIType === 3?"#1f1f1f":"white",
  }'>
    <div @click="expanded" style="padding: 4px 10px;display: flex;flex-direction: row;align-items: center;">
      <div style="display: flex;flex-direction: column;justify-content: space-between; flex:1;">
        <div style="display:flex;flex-direction: row;align-items: center;justify-content: space-between;">
          <div style="display:flex;flex-direction: row;align-items: center;">
            <div :style="hcf.getTextStyle({
          color:'main'
          })">{{ item["GameName"] }}
            </div>
            <div :style="hcf.getTextStyle({
           color:'#aaa'
          })">/{{ item["PlatWalletName"] }}/{{ item["GameCategoryName"] }}
            </div>
          </div>
          <div style="display:flex;flex-direction: row;align-items: center;">
            <div :style="hcf.getTextStyle({
          color:'#aaa'
          })">投注:
            </div>
            <div :style="hcf.getTextStyle({
            marginLeft:3,
          })">{{ hcf.getMoneyValue(item["Bet"]) }}
            </div>
          </div>
          <div style="display:flex;flex-direction: row;align-items: center;">
            <div :style="hcf.getTextStyle({
          color:'#aaa'
          })">输赢:
            </div>
            <div :style="hcf.getTextStyle({
            color:item['WinAmount']>=0?greenColor:redColor,marginLeft:3,
          })">{{ hcf.getMoneyValue(item["WinAmount"]) }}
            </div>
          </div>
        </div>
        <div :style="hcf.getTextStyle({
              color:'#aaa',addSize:-1
              })">{{hcf.getDateByMillSecs(item["BetEndTick"],1)}}
        </div>
      </div>
      <van-icon :name="isExpand?'arrow-up':'arrow-down'" size="20" color="#999" style="margin:0 5px 0 20px"/>
    </div>
    <div v-if="isExpand" style="padding: 4px 20px;display:flex;flex-direction: column;background-color: var(--ct-main-bg-color)">
      <div style="display:flex;flex-direction: row;justify-content: space-between;">
        <div style="display:flex;flex-direction: row;">
          <div :style="hcf.getTextStyle({
          addSize:-1,color:'#999'
        })">下单金额:</div>
          <div :style="hcf.getTextStyle({
          color:'main',marginLeft:5,addSize:-1
        })">{{hcf.getMoneyValue(item["Bet"])}}</div>
        </div>
        <div style="display:flex;flex-direction: row;">
          <div :style="hcf.getTextStyle({
          addSize:-1,color:'#999'
        })">派彩金额:</div>
          <div :style="hcf.getTextStyle({
          color:yellowColor,marginLeft:5,addSize:-1
        })">{{hcf.getMoneyValue(item["PayAmount"])}}</div>
        </div>
        <div style="display:flex;flex-direction: row;">
          <div :style="hcf.getTextStyle({
          addSize:-1,color:'#999'
        })">输赢金额:</div>
          <div :style="hcf.getTextStyle({
          color:item['WinAmount']>=0?greenColor:redColor,marginLeft:5,addSize:-1
        })">{{hcf.getMoneyValue(item["WinAmount"])}}</div>
        </div>
      </div>
      <div style="margin-top:2px;display:flex;flex-direction: row;">
        <div style="display:flex;flex-direction: row;">
          <div :style="hcf.getTextStyle({
          addSize:-1,color:'#999'
        })">有效投注额:</div>
          <div :style="hcf.getTextStyle({
          color:'#777',marginLeft:5,addSize:-1
        })">{{hcf.getMoneyValue(item["ValidBet"])}}</div>
        </div>
        <div style="display:flex;flex-direction: row;margin-left:30px;">
          <div :style="hcf.getTextStyle({
          addSize:-1,color:'#999'
        })">返水金额:</div>
          <div :style="hcf.getTextStyle({
          color:'#777',marginLeft:5,addSize:-1
        })">{{item["Rebate"]}}</div>
        </div>
      </div>
      <div style="margin-top:2px;display:flex;flex-direction: row;justify-content: space-between;">
        <div style="display:flex;flex-direction: row;">
          <div :style="hcf.getTextStyle({
          addSize:-1,color:'#999'
        })">投注时间:</div>
          <div :style="hcf.getTextStyle({
          color:'#777',marginLeft:5,addSize:-1
        })">{{hcf.getDateByMillSecs(item["BetStartTick"],2)}}</div>
        </div>
        <div style="display:flex;flex-direction: row;">
          <div :style="hcf.getTextStyle({
          addSize:-1,color:'#999'
        })">返水金额:</div>
          <div :style="hcf.getTextStyle({
          color:'#777',marginLeft:5,addSize:-1
        })">{{hcf.getDateByMillSecs(item["BetEndTick"],2)}}</div>
        </div>
      </div>
      <div @click="()=>{hcf.copyClipboard(item['RecordId']);}" style="margin-top:2px;display:flex;flex-direction: row;">
        <div style="display:flex;flex-direction: row;">
          <div :style="hcf.getTextStyle({
          addSize:-1,color:'#999'
        })">注单编号:</div>
          <div :style="hcf.getTextStyle({
          color:'#777',marginLeft:5,addSize:-1
        })">{{item["RecordId"]}}</div>
        </div>
        <div :style='{
          borderRadius: "3px",
          backgroundColor: HNewGameUIConfig.newGameUIType === 3?"#111":"#eaeaea",
          padding: "1px 3px",
          marginLeft:"5px",
        }'>
          <div :style="hcf.getTextStyle({
          color:'main',addSize:-3
        })">复制</div>
        </div>
      </div>
      <div style="margin-top:2px;display:flex;flex-direction: row;">
        <div :style="hcf.getTextStyle({
          addSize:-1,color:'#999'
        })">投注内容:</div>
        <div :style="hcf.getTextStyle({
          color:'#777',marginLeft:5,addSize:-1
        })">{{item["ExternInfo"]}}</div>
      </div>
    </div>
  </div>
</template>


<script setup>

  import {hcf} from "../../utils/HComFunctions.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  const props = defineProps(["item","index"]);

  let yellowColor = "#ef9824";
  let greenColor = "#10a601";
  let redColor = "#fd1e47";

  let isExpand = ref(props.index === 0);

  function expanded(){
    isExpand.value = !isExpand.value;
  }

</script>
